import { root } from '@estee/elc-universal-utils';
import { HttpTransport } from './HttpTransport';

if (root && !root.HttpTransport) {
    root.HttpTransport = new HttpTransport();
}

export { HttpTransport, IResponse, IHeaderSetter } from './HttpTransport';
export { DataMapper, IDataMapper, IDataMapperOperations } from './datamapper/DataMapper';
